import { render, staticRenderFns } from "./formGuiaDespachoExportacion.vue?vue&type=template&id=2b03bfca&scoped=true&"
import script from "./formGuiaDespachoExportacion.vue?vue&type=script&lang=js&"
export * from "./formGuiaDespachoExportacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03bfca",
  null
  
)

export default component.exports